export default __webpack_public_path__ + "static/media/8419d735f58888a11f293b2f6aabc57b.svg";